import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@lt/localization';
import LayersControlMessage from './LayersControlMessage';

const LayersControlDemo = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <LayersControlMessage onClose={onClose} tooltipOffset={58}>
      <h3>{t('map.controls.demo.interesting')}</h3>
      <div>{t('map.controls.demo.text')}</div>
    </LayersControlMessage>
  );
};

LayersControlDemo.defaultProps = {
  onClose: null,
};
LayersControlDemo.propTypes = {
  onClose: PropTypes.func,
};

export default LayersControlDemo;
